import script from "./task-detail.vue?vue&type=script&lang=tsx&setup=true"
export * from "./task-detail.vue?vue&type=script&lang=tsx&setup=true"

import "./task-detail.vue?vue&type=style&index=0&id=d99d938e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d99d938e"]])

export default __exports__